import { Directive, Input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

@Directive({
  selector: '[appMinimumOptionSelectionValidation]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MinimumOptionSelectionValidationDirective,
      multi: true,
    },
  ],
})
export class MinimumOptionSelectionValidationDirective {
  @Input('appMinimumOptionSelectionValidation') minOptionSelection = 0;

  validate(control: AbstractControl): ValidationErrors | null {
    return this.minOptionSelection > 0
      ? minOptionSelectionValidator(this.minOptionSelection)(control)
      : null;
  }
}

export function minOptionSelectionValidator(minValue: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return control?.value?.length < minValue
      ? { minSelection: `Please select atleast ${minValue} options` }
      : null;
  };
}

export function minArrayLengthValidator(min: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const arrayValue = control.value;
    if (Array.isArray(arrayValue) && arrayValue?.length >= min) {
      return null; // Array has at least min length, validation passes
    } else {
      return {
        minArrayLength: {
          requiredLength: min,
          actualLength: arrayValue?.length,
        },
      };
    }
  };
}
